import { render, staticRenderFns } from "./FederationPlanPreview.vue?vue&type=template&id=3db75df2&scoped=true"
import script from "./FederationPlanPreview.vue?vue&type=script&lang=js"
export * from "./FederationPlanPreview.vue?vue&type=script&lang=js"
import style0 from "./FederationPlanPreview.vue?vue&type=style&index=0&id=3db75df2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db75df2",
  null
  
)

export default component.exports